// Кодмод Фазы 1 миграции на Vite (13.08.2026): require('*.png') → ESM-импорты.
// Vite не исполняет CommonJS в браузере ('require is not defined'); webpack
// понимает ESM-импорты ассетов так же (asset/resource → URL-строка).
import img0 from '@images/UI/Emoji/speech_balloon.png';
import img1 from '@images/UI/Emoji/speech_balloon@2x.png';
import img2 from '@images/UI/Emoji/speech_balloon@3x.png';
import img3 from '@images/UI/Emoji/star2.png';
import img4 from '@images/UI/Emoji/star2@2x.png';
import img5 from '@images/UI/Emoji/star2@3x.png';

export default {
  emoji: {
    speechBalloon: {
      x1: img0,
      x2: img1,
      x3: img2
    },
    star2: {
      x1: img3,
      x2: img4,
      x3: img5
    }
  }
};
